import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { ReligionBranchType } from '../../../../objects';


@Component({
  selector: 'app-religion-branch-type',
  templateUrl: './religion-branch-type.component.html',
  styleUrls: ['./religion-branch-type.component.css']
})
export class ReligionBranchTypeComponent implements OnInit {

  public data: ReligionBranchType[];
  public isLoading = false;

    constructor(
      public dialog: MatDialog,
      private apiSvc: ApiService
    ) { }

    ngOnInit() {
      this.loadElements();
    }

    private loadElements() {
      this.isLoading = true;
      this.apiSvc.get("api/ReligionBranchType/", null).subscribe(
        (data: ReligionBranchType[]) => {
          this.data = data;
          console.log(this.data);
          this.isLoading = false;
        },
        (err) => {
          console.log("error", err);
          this.isLoading = false;
        }
     );
    }

    public add() {
     // const dialogRef = this.dialog.open(ReligionBranchEditComponent, {});
    }

    public edit(obj: ReligionBranchType) {
      console.log(obj);
    //  const dialogRef = this.dialog.open(ReligionBranchEditComponent, { });
    }

    public delete(obj) {
       alert("Delete");
    }


}
